import actions from './actions'
import mutations from './mutations'
import getters from './getters'
export default {
    state: {
        events: [],
        event_pages: 0,
        new_event: {
            name: '',
            description: '',
            start: new Date().toDateString(),
            end: new Date().toDateString()
        },
        calendars: [],
        new_calendar: {
            name: '',
            description: '',
            color: '#dc3545'
        }
    },
    actions,
    mutations,
    getters
}
